import TDrag from './sortable'

TDrag.install = Vue => {
  Vue.directive(TDrag.name, TDrag)
}

export default TDrag



// WEBPACK FOOTER //
// ./src/module/drag/index.js